import React, { useState, useEffect, useContext } from 'react';
import styles from './PurchaseCancellation.module.css';
import axios from 'axios';
import { LanguageContext } from '../../Component/LanguageContext/LanguageContext';

const PurchaseCancellation = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${marketingBackendUrl}/maflam/subfooter-pages/67c9130e09e1623ca9f73562`
        );
        setPageData(response.data.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [marketingBackendUrl]);

  const getArabicNumber = (num) => {
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return num.toString().split('').map(digit => arabicNumbers[parseInt(digit)]).join('');
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!pageData) return <div>No data available</div>;

  const renderContent = (item) => {
    const formatSubItem = (content) => {
      const parts = content.split(':');
      
      const formatText = (text) => {
        return text.replace(
          /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi,
          (match) => `<span class="${styles.emailText}">${match}</span>`
        ).split(/(<span.*?<\/span>)/).map((part, index) => {
          if (part.startsWith('<span')) {
            const email = part.match(/>(.+?)</)[1];
            return <span key={index} className={styles.emailText}>{email}</span>;
          }
          return part;
        });
      };

      if (parts.length > 1) {
        return (
          <>
            <span className={styles.boldPart}>{parts[0]}:</span>
            {formatText(parts.slice(1).join(':'))}
          </>
        );
      }
      return formatText(content);
    };

    switch (item.type) {
      case 'paragraph':
        return (
          <div className={styles.paragraphSection}>
            <p className={`${styles.description} ${
              pageData.items[pageData.items.length - 1] === item ? 
              styles.lastParagraph : ''
            }`}>
              {formatSubItem(isRTL ? item.contentArabic : item.contentEnglish)}
            </p>
            {item.subItems && item.subItems.length > 0 && (
              <ul  className={styles.subList}>
                {item.subItems.map((subItem, idx) => (
                  <li  key={idx} className={styles.subListItem}>
                    {formatSubItem(isRTL ? subItem.contentArabic : subItem.contentEnglish)}
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      
      case 'numberedHeading':
        return (
          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>
              {isRTL ? 
                `${getArabicNumber(item.number)}. ${item.contentArabic}` : 
                `${item.number}. ${item.contentEnglish}`
              }
            </h2>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop:'0px',paddingBottom:'0px' , paddingLeft:'20px', paddingRight:'20px', margin:'0px'}}>
            {item.subItems && item.subItems.length > 0 && (
              <ul style={{marginBottom:'0px'}} className={styles.list}>
                {item.subItems.map((subItem, idx) => (
                  <li key={idx} className={styles.listItem}>
                    {formatSubItem(isRTL ? subItem.contentArabic : subItem.contentEnglish)}
                  </li>
                ))}
              </ul>
            )}
            </div>
          </div>
        );

      case 'bulletPoint':
        return (
          <ul className={styles.list}>
            <li style={{paddingLeft: '0px' , paddingRight: '0px'}} className={styles.listItem}>
              {isRTL ? item.contentArabic : item.contentEnglish}
            </li>
            {item.subItems && item.subItems.length > 0 && (
              <ul style={{paddingLeft: '20px' , paddingRight: '20px'}} className={styles.subList}>
                {item.subItems.map((subItem, idx) => (
                  <li  style={{paddingLeft: '0px' , paddingRight: '0px'}} key={idx} className={styles.subListItem}>
                    {formatSubItem(isRTL ? subItem.contentArabic : subItem.contentEnglish)}
                  </li>
                ))}
              </ul>
            )}
          </ul>
        );

      default:
        return null;
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <h1 className={styles.title}>
          {isRTL ? pageData.headingInArabic : pageData.headingInEnglish}
        </h1>
        
        {pageData.items.map((item, index) => {
          if (item.type === 'numberedHeading') {
            // Get count of previous numbered headings
            const headingNumber = pageData.items
              .slice(0, index)
              .filter(i => i.type === 'numberedHeading')
              .length + 1;
              
            item = {
              ...item,
              number: headingNumber
            };
          }
          return (
            <div key={index}>
              {renderContent(item)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PurchaseCancellation;
